import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    InputItem,
    ButtonItem,
    ErrorItem,
    InputNumberItem,
} from "../../../../Components/Items";
import SelectEmpleadosItem from "../../../../Components/SelectEmpleadosItem";
import SelectRelojesChecadoresItem from "../../../../Components/SelectRelojesChecadoresItem";

class AgegarAsignacionReloj extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }
    cerrarAgregarAsignacionReloj(codigo) {
        this.props.cerrarAgregarAsignacionReloj(codigo);
    }
    async consultarTodo() {
        this.setState({ loading: true });
        this.setState({ loading: false });
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "asignacionesRelojes/agregarAsignacionReloj",
                { ...values, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha registrado una asignación de reloj checador");
                    this.formRef.current.resetFields();
                    this.cerrarAgregarAsignacionReloj(res.data.codigo);
                } else if (res.data.success === 1) {
                    message.error(res.data.message || "No se puede registrar la asignación de reloj checador");
                } else {
                    message.error(res.data.message || "Hubo un error y la asignación de reloj checador no se registro");
                }
            });
    }
    render() {
        return (
            <>
                <ModalItem
                    title="Agregar Asignación de Reloj Checador"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarAgregarAsignacionReloj.bind(this)}
                    paddingTop
                >
                    <Form
                        ref={this.formRef}
                        name="agregarAsignacionReloj"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Agregar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <FormItem
                            name="nombre"
                            label="Nombre"
                            max={100}
                            margin
                            pattern
                        >
                            <InputItem placeholder="Nombre" />
                        </FormItem>
                        <FormItem
                            label="Reloj Checador"
                            name="relojChecadorId"
                            fieldKey="relojChecadorId"
                            margin
                        >
                            <SelectRelojesChecadoresItem
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                sinBorde
                                autoFocus
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Reloj Checador"
                                onChange={(value, reloj) => {
                                    this.formRef.current.setFieldsValue({ relojChecadorId: value });
                                    if (reloj?.numeroSiguiente !== undefined) {
                                        this.formRef.current.setFieldsValue({ usuarioRelojChecador: Number(reloj.numeroSiguiente) });
                                    }
                                }}
                            />
                        </FormItem>
                        <FormItem
                            label="Empleado"
                            name="empleadoId"
                            fieldKey="empleadoId"
                            margin
                        >
                            <SelectEmpleadosItem
                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                headersToken={this.props.headersToken}
                                sinBorde
                                autoFocus
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Empleados"
                            />
                        </FormItem>
                        <FormItem
                            name="usuarioRelojChecador"
                            label="Usuario Reloj"
                            required
                            type="number"
                            margin
                            pattern
                        >
                            <InputNumberItem placeholder="Usuario Reloj" />
                        </FormItem>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(AgegarAsignacionReloj);
